<alaris-dialog
	[closeAction]="close.bind(this)"
	[confirmAction]="confirm.bind(this)"
	[loading$]="manualDippingService.loading$"
	size="md">
	<h6 slot="header">{{ 'manual_dipping.removingDialog' | translate }}</h6>
	<div slot="content">
		<h3>
			<strong>DD-{{ data.mdTask.mdTaskID }}</strong>
		</h3>
	</div>
</alaris-dialog>
